import React, { useEffect, useState } from "react";

const AplyIdProcessing = ({ getData }) => {
  const [emitter, setEmitter] = useState(getData().getEmitter());
  const [hasProcessingStarted, setHasProcessingStarted] = useState(false);

  useEffect(() => {
    return () => {
      emitter?.off?.();
    };
  }, []);

  useEffect(() => {
    emitter.on &&
      emitter.on("ValueChanged", () => {
        const hasAplyIdBeenSubmitted =
          getData().getFieldValue("6333eb07266d7f003b37b9b7") === "YES";

        if (hasAplyIdBeenSubmitted && !hasProcessingStarted) {
          setHasProcessingStarted(true);
        }
      });
  }, [emitter]);

  return (
    <div>
      Your identity documents are being processed.
      <br /> This typically takes 30-60 seconds.
      <br />
      You will be redirected to continue your application after verification is
      processed.
    </div>
  );
};

export default AplyIdProcessing;
